<template>
    <v-card class="my-2">
        <v-card-title class="justify-center">Virtual assistant</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-2 px-5">
            <v-row>
                <v-col cols=3>OpenAI Model</v-col><v-col cols=9>{{ assistant.model }}</v-col>
            </v-row>
            <v-row>
                <v-col cols=3>Name</v-col><v-col cols=9>{{ assistant.name }}</v-col>
            </v-row>
            <v-row>
                <v-col cols=3>Description</v-col><v-col cols=9>{{ assistant.description }}</v-col>
            </v-row>
            <!-- <v-row>
                <v-col cols=3>Vector store</v-col><v-col cols=9>{{ assistant.vectorStoreName }}</v-col>
            </v-row> -->
            <v-row>
                <v-col cols=3>Temperature</v-col><v-col cols=1>{{ temperature / 10 }}</v-col><v-col cols=8><v-slider v-model="temperature" min="0" max="20" dense></v-slider></v-col>
            </v-row>
            <v-row>
                <v-col cols=3>Instructions</v-col><v-col cols=9><v-textarea v-model="assistant.instructions" rows="4" dense></v-textarea></v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-2">
            Note: <br>
            <br>
            The model is fixed at gpt-40-mini (a cost effective option).<br>
            The documentation for temperature says: "What sampling temperature to use, between 0 and 2. 
            Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic."
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="saveAssistant()">Update Assistant</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        components: {
        },
        props: {
            assistant_id: {
                required: true,
            }
        },
        data() {
            return {
                dialog: false,

                assistant: {},
                vectorStoreCodes: [],

                temperature: 0,
            }
        },
        mounted() {
            this.getAssistant();
        },
        methods: {
            getAssistant() {
                this.$axios.post("ares/json/ares/syst/openai/getAssistant.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAssistant",
                    },
                    getAssistant: {
                        assistant_id: this.assistant_id,
                    }
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.assistant = res.data.getAssistant.assistant;
                        this.temperature = this.assistant.temperature * 10;
                    }
                });

            },
            saveAssistant() {
                if (this.assistant.instructions === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Please give the assistant proper instructions",
                        color: "error",
                    });  
                    return
                }
                this.assistant.temperature = this.temperature;
                this.$axios.post("ares/json/ares/syst/openai/saveAssistant.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveAssistant",
                    },
                    saveAssistant: this.assistant,
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveAssistant.text,
                            color: res.data.saveAssistant.color,
                        });
                    }
                });
            },
        }
    }
</script>
